import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  heading: {
    color: "black"
  },
  iconstyle: {
    cursor: "pointer",
    width: "50px",
    height: "50px",
    position: "fixed",
    bottom: "10px",
    right: "10px",
    zIndex: "5",
    [theme.breakpoints.down("md")]: {
      bottom: "60px"
    },
    [theme.breakpoints.down("sm")]: {
      bottom: "48px"
    }
  },

  ChatModalWrap: {
    backgroundColor: theme?.palette?.primaryBG?.[400],
    maxWidth: "600px",
    width: "100%",
    position: "fixed",
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    paddingBottom: "10px",
    borderRadius: "10px",
    zIndex: "99",
    boxShadow: `1px 0px 20px 8px ${theme?.palette?.secondaryText?.[700]}`,
    // maxHeight: "70vh",
    // [theme.breakpoints.down("lg")]: {
    //   maxWidth: "100%",
    // },
    [theme.breakpoints.down("md")]: {
      minWidth: "auto",
      width: "98%",
      margin: "0 auto",
      maxHeight: "100%",
      overflow: "auto"
    }
  },
  head: {
    backgroundColor: theme?.palette?.primaryBG?.[400],
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "10px 10px 0px 0",
    padding: "10px",
    position: "relative",
    borderBottom: `8px solid ${theme?.palette?.secondaryText?.[700]}`,
    paddingBottom: "10px",
    "& .MuiButton-containedSecondary:hover": {
      backgroundColor: theme?.palette?.primaryBG?.[300],
      color: theme?.palette?.primaryText?.[100]
    }
  },
  CloseModal: {
    position: "absolute",
    right: "10px",
    top: "18px",
    [theme.breakpoints.down("md")]: {
      top: "14px",
      right: "0px"
    },
    "& img,svg": {
      width: "15px",
      height: "15px"
    }
  },
  btnPrimary: {
    backgroundColor: theme?.palette?.primaryBG?.[250],
    borderRadius: "30px",
    fontWeight: "bold",
    color: theme?.palette?.primaryText?.[100],
    fontSize: "14px",
    padding: "6px 40px",
    textTransform: "capitalize",
    [theme.breakpoints.down("md")]: {
      padding: "6px 20px",
      fontSize: "10px"
    },
    "&:hover": {
      backgroundColor: theme?.palette?.primaryBG?.[300],
      color: theme?.palette?.primaryText?.[100]
    }
  },

  sendPrimary: {
    backgroundColor: theme?.palette?.secondaryBG?.main,
    borderRadius: "30px",
    fontWeight: "bold",
    color: theme?.palette?.secondaryText?.[700],
    fontSize: "14px",
    padding: "6px 40px",
    textTransform: "capitalize",
    [theme.breakpoints.down("md")]: {
      padding: "6px 20px"
    }
  },
  submitBtnWrap: {
    padding: "10px 0 0px",

    "& .MuiButtonBase-root": {
      width: "100%",
      padding: "10px 30px",
      fontSize: "16px",
      "&:hover": {
        backgroundColor: theme?.palette?.primaryBG?.[300],
        color: theme?.palette?.primaryText?.[100]
      }
    }
  },
  formWrap: {
    padding: "10px 15px",
    "& .MuiFormLabel-root": {
      color: `${theme?.palette?.primaryText?.[100]} !important`,
      opacity: "0.70"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(255 255 255 / 40%)"
    },
    "& .MuiInputBase-input": {
      borderColor: "rgb(255 255 255 / 40%)"
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "0.625rem",
      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgb(255 255 255 / 40%)"
        }
      }
    }
  },
  loaderWrap: {
    height: "380px",
    background: theme?.palette?.primaryBG?.[400],
    marginLeft: "5px"
  },
  inputgroup: {
    width: "100%",
    margin: "10px 0 15px",
    background: theme?.palette?.primaryBG?.[700]
  },

  messagegroup: {
    width: "100%"
  },
  wrapMessage: {
    "& .MuiInputLabel-root": {
      color: theme?.palette?.primaryText?.[100]
    }
  },
  pagination: {
    marginTop: "10px"
    // marginLeft: "15px"

    // overflowY: "auto",
    // height: "367px",
  },
  paginationBtn: {
    color: theme?.palette?.primaryText?.[100],
    marginRight: "2px",
    marginLeft: "2px",
    borderRadius: "100%",
    minWidth: "18px",
    width: "18px",
    height: "18px",
    padding: "0px",
    fontSize: "12px",
    cursor: "pointer"
  },
  paginationBtnNextPrev: {
    color: theme?.palette?.primaryText?.[100],
    marginRight: "2px",
    borderRadius: "100%",
    minWidth: "14px",
    height: "14px",
    cursor: "pointer"
  },
  subjectlist: {
    backgroundColor: theme?.palette?.primaryBG?.[400],
    borderRadius: "0px",
    padding: "5px 10px",
    width: "100%",
    fontSize: "12px",
    cursor: "pointer",
    marginTop: "14px",
    borderBottom: `0.5px solid ${theme?.palette?.primaryText?.[300]}`,
    "& span": {
      whiteSpace: "nowrap",
      overflowX: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      width: "100px",
      display: "block",
      fontSize: "14px"
    }
  },

  subjectListWrap: {
    justifyContent: "space-between",
    display: "flex",
    flexFlow: "column",
    minHeight: "350px"
  },
  pageNumber: {
    display: "inline-block",
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor:
      "purple" /* Change the background color as per your preference */,
    color: theme?.palette?.primaryText?.[100],
    fontSize: "14px",
    textAlign: "center",
    lineHeight: "30px"
  },
  subjectWrap: {
    fontWeight: "bold",
    display: "block",
    wordBreak: "break-word",
    padding: "10px",
    marginLeft: "5px",
    background: theme?.palette?.primaryBG?.[400],
    [theme.breakpoints.down("lg")]: {
      fontSize: "14px"
    }
  },
  circularprogress: {
    backgroundColor: theme?.palette?.primaryBG?.[350]
  },
  username1: {
    textAlign: "right",
    fontSize: "14px"
  },
  username2: {
    textAlign: "left",
    fontSize: "14px"
  },
  textMessageUser1: {
    backgroundColor: theme?.palette?.primaryBG?.[250],
    padding: "6px",
    color: theme?.palette?.primaryText?.[100],
    borderRadius: "10px 10px 0px 10px",
    display: "inline-block",
    wordBreak: "break-word",
    maxWidth: "70%",
    fontWeight: "600",
    "& .chat-img": {
      background: "transparent",
      border: "none",
      display: "block",
      "& img,svg": {
        height: "100px",
        width: "100px"
      }
    }
  },
  textMessageUser2: {
    backgroundColor: theme?.palette?.secondaryBG?.main,
    padding: "6px",
    color: theme?.palette?.secondaryText?.[700],
    borderRadius: "10px 10px 10px 0px",
    display: "inline-block",
    wordBreak: "break-word",
    maxWidth: "70%",
    fontWeight: "600",
    marginLeft: "5px",
    "& .chat-img": {
      background: "transparent",
      border: "none",
      display: "block",
      "& img,svg": {
        height: "100px",
        width: "100px"
      }
    }
  },
  paginationWrap: {
    padding: "5px 0px 0"
  },
  chatScroll: {
    overflow: "auto",
    height: "380px",
    paddingRight: "5px",
    background: theme?.palette?.primaryBG?.[400],
    marginLeft: "5px",
    borderRadius: "0px 0px 0px 10px"
  },
  chatSendBox: {
    position: "relative",
    paddingRight: "10px",
    background: theme?.palette?.primaryBG?.[650],
    borderRadius: "5px",
    [theme.breakpoints.down("md")]: {
      // paddingLeft: "10px"
    },
    "& .MuiFormControl-root": {
      width: "100%",
      padding: "5px",
      borderRadius: "30px",
      fontSize: "14px",

      "& .MuiInputBase-input": {
        borderRadius: "10px",
        background: theme?.palette?.primaryBG?.[400],
        padding: "14px 10px",
        marginRight: "5px"
      }
    },
    "& .MuiInputBase-root": {
      paddingRight: "30px",
      "&:before": {
        display: "none"
      },
      "&:after": {
        display: "none"
      }
    }
  },
  sendIcon: {
    cursor: "pointer",
    outline: "none",
    position: "absolute",
    right: "8px",
    top: "7px",
    borderRadius: "10px",
    background: `${theme?.palette?.secondaryBG?.main} !important`,
    fontSize: "5px",
    padding: "8px",
    height: "47px",
    fill: theme?.palette?.secondaryText?.[700],
    width: "35px"
  },
  subjectTab: {
    background: theme?.palette?.primaryBG?.[700],
    padding: "10px"
  },
  subjectInMobile: {
    padding: "10px",
    background: theme?.palette?.primaryBG?.[700]
  },
  listTab: {
    backgroundColor: theme?.palette?.primaryBG?.[250],
    borderRadius: "30px",
    cursor: "pointer",
    padding: "10px 30px",
    minHeight: "auto",
    color: theme?.palette?.primaryText?.[100],
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: theme?.palette?.secondaryBG?.main,
      color: theme?.palette?.supportChatText?.main
    }
  },
  selectedSubject: {
    backgroundColor: theme?.palette?.secondaryBG?.main,
    color: theme?.palette?.secondaryText?.[700]
  },
  pageNumberSpacing: {
    margin: "-24px -24px -24px -24px" // Adjust the margin value as per your preference
  },
  mobileMessage: {
    width: "100%",
    overflow: "auto",
    height: "262px",
    padding: "5px 10px"
  },
  isactive: {
    backgroundColor: theme?.palette?.secondaryBG?.main,
    color: theme?.palette?.secondaryText?.[700],
    "&:hover": {
      backgroundColor: theme?.palette?.secondaryBG?.main,
      color: theme?.palette?.supportChatText?.main
    }
  },
  subjectLoader: {
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSkeleton-root": {
      height: "100%"
    }
  },
  tabText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100px",
    fontSize: "12px"
  },
  msgLoader: {
    color: theme?.palette?.primary2TextColor?.main
  },
  fileUploadWrap: {
    marginTop: "20px"
  },
  messageWrap: {
    "& .MuiInputBase-root": {
      display: "grid",
      background: theme?.palette?.primaryBG?.[700]
    }
  },
  selectedImgName: {
    marginLeft: "10px",
    fontSize: "12px"
    // position:"reltive",
  },
  textFieldEndIconBtn: {
    borderRadius: "10px",
    height: "47px",
    background: theme?.palette?.secondaryBG?.main,
    color: theme?.palette?.secondaryText?.[700],
    "&:hover": {
      backgroundColor: theme?.palette?.secondaryBG?.main
    }
  },
  attachmentImgWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "10px",
    background: theme?.palette?.primaryBG?.[300],
    borderRadius: "10px 10px 10px 10px",
    // position:"relative",
    // top:"-54px",
    // right:"0",
    [theme.breakpoints.down("md")]: {
      maxWidth: "280px"
    }
  },
  toolTipWrap: {
    background: theme?.palette?.primary2TextColor?.main,
    fontSize: "10px",
    fontWeight: "600",
    color: theme?.palette?.secondaryText?.[700]
  },
  toolTipArrow: {
    color: theme?.palette?.primary2TextColor?.main
  },
  sendIconPosition: {
    position: "relative",
    "& .MuiInputBase-root": {
      display: "block"
    },
    "& .MuiFormControl-root": {
      width: "100%",
      padding: "5px 15px",
      fontSize: "14px",
      borderRadius: "12px",
      backgroundColor: theme?.palette?.primaryBG?.[400],
      border: `1px solid ${theme?.palette?.supportChatText?.border}`,
      position: "relative",
      marginLeft: "5px",
      "& .MuiInputBase-root": {
        "&:before": {
          display: "none"
        }
      }
    }
    // "& .MuiBadge-root" :{
    //   position:"absolute",
    //   right:"40px",
    //   top:"-4px",
    // }
  },
  dialogImageWrap: {
    height: "auto !important",
    "& .close-btn": {
      color: theme?.palette?.primaryText?.[100]
    }
  },
  dialogImage: {
    height: "auto !important",
    padding: "5px",
    background: theme?.palette?.primaryBG?.[250],
    "& .dialog-img-wrap": {
      height: "500px",
      background: "transparent",
      overflow: "hidden",
      "& img,svg": {
        width: "100%",
        height: "100%"
      },
      [theme.breakpoints.down("md")]: {
        height: "auto"
      }
    }
  },
  fileAttachBtn: {
    display: "flex",
    "& .MuiBadge-root": {
      borderRadius: "10px"
    }
  },
  msgInputCta: {
    display: "flex",
    alignItems: "center",
    "& .MuiBadge-root": {
      background: theme?.palette?.primaryBG?.[350],
      borderRadius: "10px"
    }
  },
  attachmentBadge: {
    marginTop: "10px"
  },
  btnClose: {
    backgroundColor: theme?.palette?.primaryBG?.[250],
    borderRadius: "30px",
    fontWeight: "bold",
    color: theme?.palette?.primaryText?.[100],
    fontSize: "14px",
    padding: "6px 40px",
    textTransform: "capitalize",
    position: "absolute",
    right: "7px",
    top: "10px",
    [theme.breakpoints.down("md")]: {
      padding: "6px 20px",
      top: "9px",
      fontSize: "10px"
    },
    "&:hover": {
      backgroundColor: theme?.palette?.primaryBG?.[300],
      color: theme?.palette?.primaryText?.[100]
    }
  },
  newqueryStyle: {
    margin: "0px",
    fontWeight: "bold",
    color: theme?.palette?.primary2TextColor?.main
  },
  titleDetails: {
    marginBottom: "10px",
    opacity: "0.50",
    margin: "0px",
    fontSize: "12px"
  },
  messageDetails: {
    marginBottom: "0px",
    opacity: "0.50",
    fontSize: "12px"
  },
  chatWrap: {
    // background: theme?.palette?.primaryBG?.[700],
    width: "100%",
    padding: "5px",
    marginTop: "15px"
  },
  querysentWrap: {
    paddingTop: "80px",
    background: theme?.palette?.primaryBG?.[400]
  },
  querysuccessWrap: {
    marginTop: "50px",
    "& img,svg": {
      width: "100px"
    }
  },
  QuerySentIcon: {
    justifyContent: "center",
    display: "flex"
  },
  skeletonprogress: {
    height: "100%"
  },
  skeletonLoader: {
    height: "262px"
  },
  cancelBtn: {
    minWidth: "30px !important",
    color: theme?.palette?.primaryText?.[100],
    fontWeight: "700"
  },
  attachmentIconBtn: {
    borderRadius: "10px",
    height: "47px",
    background: theme?.palette?.primaryBG?.[300],
    color: theme?.palette?.primaryText?.[100],
    "&:hover": {
      backgroundColor: theme?.palette?.primaryBG?.[300],
      color: theme?.palette?.primaryText?.[100]
    }
  },
  selectedImgWrap: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // position:"relative",
    // top:"-54px",
    // right:"0",
    [theme.breakpoints.down("md")]: {
      maxWidth: "280px"
    }
  },
  sendMessage: {
    overflow: "auto",
    height: "330px",
    paddingRight: "5px",
    background: theme?.palette?.primaryBG?.[400],
    marginLeft: "5px"
  },
  paginationIconWrap: {
    "&.MuiButtonBase-root": {
      background: theme?.palette?.primaryBG?.[400],
      padding: "0.125rem",
      "& .MuiSvgIcon-root": {
        color: theme?.palette?.primary2TextColor?.main
      },
      "&:hover": {
        backgroundColor: theme?.palette?.primary2TextColor?.main,
        "& .MuiSvgIcon-root": {
          color: theme?.palette?.secondaryText?.[700]
        }
      }
    }
  },
  supportPaginationWrap: {
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    marginTop: "8px",
    "& .MuiPaginationItem-root": {
      fontSize: "12px"
    }
  },
  supportPaginationLoader: {
    marginTop: "30px",
    "& .MuiPaginationItem-root": {
      fontSize: "12px"
    }
  },
  chatEnded: {
    "&.MuiTypography-root": {
      color: theme?.palette?.secondaryBG?.main,
      fontWeight: "500",
      [theme.breakpoints.down("md")]: {
        padding: "0 10px",
        fontSize: "14px"
      }
    }
  }
}));
